import { get } from './generic.api';

export const fetchCategories = async () => {
  try {
    const response = await get('/clients/intranet/category/', {
      page_size: 100,
    });

    const list = Array.isArray(response) ? response : response.results;

    return list.map((cat) => ({
      value: cat.id,
      label: cat.name,
    }));
  } catch (error) {
    console.error('Erro ao carregar categorias:', error.response);
    throw error;
  }
};